export default "__VITE_ASSET__iBLcc3k3__"